export default {
  SQUARE: 1,
  ROUND: 2,
};



// WEBPACK FOOTER //
// ./src/default-settings/layout-style-values.js